import React from 'react';

import {
  Help,
  Stack,
  Grid,
  Section,
  CheckboxGroupOption,
} from '@gogame/components';
import { FormField, withForm, SidePageV2 } from '@gogame/form';
import { useIsAllowed } from '@gogame/permissions';

import { PERMISSION_DOWNLOAD_NON_HASHED } from 'scenes/CustomAudiences/Audiences/constants';
import {
  loadHashTypes,
  loadDataTypes,
  loadCases,
} from 'scenes/CustomAudiences/Audiences/sources/fields';

import {
  HASH_TYPE,
  DATA_TYPE,
  HASH_TYPE_NON_HASHED,
  IS_DASHED_INCLUDED,
  IS_VALUE_PROVIDED,
  IS_BOT_INCLUDED,
  HASH_TYPE_MD5,
  DATA_TYPE_LAST_UID,
  CASE,
  CASE_TYPE,
  INCLUDE,
} from './constants';

const getLabel = ({ name, hint }) => {
  return (
    <Stack spacing={1} direction={'row'}>
      <span>{name}</span>
      {hint && <Help>{hint}</Help>}
    </Stack>
  );
};

const getHashTypeLabel =
  (isAllowedNonHashed) =>
  ({ name, id }) => (
    <Stack spacing={1} direction={'row'}>
      <span>{name}</span>
      {id === HASH_TYPE_NON_HASHED && !isAllowedNonHashed ? (
        <Help>Not allowed by permissions</Help>
      ) : null}
    </Stack>
  );
const getOptionDisabled =
  (isAllowedNonHashed) =>
  ({ id }) =>
    id === HASH_TYPE_NON_HASHED && !isAllowedNonHashed;

const Download = withForm({
  mapPropsToValues: () => ({
    [HASH_TYPE]: HASH_TYPE_MD5,
    [DATA_TYPE]: DATA_TYPE_LAST_UID,
    //maybe need too change to another default value
    [CASE]: CASE_TYPE,
  }),
})(({ name, onClose, loading, onExited, open }) => {
  const isAllowedDownloadNonHashed = useIsAllowed()(
    PERMISSION_DOWNLOAD_NON_HASHED
  );
  return (
    <SidePageV2
      onClose={onClose}
      onExited={onExited}
      loading={loading}
      open={open}
    >
      <SidePageV2.Title title={'Export Audience'} subTitle={name} />
      <SidePageV2.NewBody>
        <Section title={'Export Settings'}>
          <Grid container spacing={2}>
            <Grid container item spacing={2}>
              <Grid item xs={6}>
                <FormField.RadioGroup
                  title={'Encryption'}
                  source={loadHashTypes}
                  padding={0}
                  name={HASH_TYPE}
                  radioVertical={true}
                  vertical={true}
                  getOptionLabel={getHashTypeLabel(isAllowedDownloadNonHashed)}
                  isOptionDisabled={getOptionDisabled(
                    isAllowedDownloadNonHashed
                  )}
                />
              </Grid>
              <Grid item xs={6}>
                <FormField.RadioGroup
                  title={'Data Type'}
                  source={loadDataTypes}
                  padding={0}
                  name={DATA_TYPE}
                  radioVertical={true}
                  vertical={true}
                  getOptionLabel={getLabel}
                />
              </Grid>
            </Grid>
            <Grid container item spacing={2}>
              <Grid item xs={6}>
                <FormField.RadioGroup
                  title={'Case'}
                  source={loadCases}
                  padding={0}
                  name={CASE}
                  radioVertical={true}
                  vertical={true}
                  getOptionLabel={getLabel}
                />
              </Grid>
              <Grid item xs={6}>
                <FormField.CheckboxGroup
                  padding={0}
                  align={'center'}
                  title={'Include'}
                  checkboxVertical={true}
                  name={INCLUDE}
                >
                  <CheckboxGroupOption
                    value={IS_VALUE_PROVIDED}
                    label={'Values'}
                  />
                  <CheckboxGroupOption value={IS_BOT_INCLUDED} label={'Bots'} />
                  <CheckboxGroupOption
                    value={IS_DASHED_INCLUDED}
                    label={'Dashed'}
                  />
                </FormField.CheckboxGroup>
              </Grid>
            </Grid>
          </Grid>
        </Section>
      </SidePageV2.NewBody>
      <SidePageV2.Actions>
        <SidePageV2.CloseButton />
        <SidePageV2.SubmitButton>Export</SidePageV2.SubmitButton>
      </SidePageV2.Actions>
    </SidePageV2>
  );
});

export default Download;
